import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';

import Datatable from '../../components/Datatable/';

import {
  getAllIVRs,
  removeIVRs,
  restoreIVRs,
  getAllIVRsOptions
} from '../../redux/actions/ivrs';
import TableHeader from '../../components/TableHeader';
import ModalRemoveItem from '../../components/ModalRemoveItem';
import ModalRestoreItem from '../../components/ModalRestoreItem';

function List () {
  const ivrs = useSelector(state => state.ivrs);
  const dispatch = useDispatch();
  const authentications = useSelector(state => state.authentications);
  const nameUser = authentications.user.name.toLowerCase();
  const tableData = ivrs.data.filter(item => {
    return item.active || nameUser === 'root' || nameUser === 'administrator'
      ? item
      : false;
  });
  const [showModalRemove, setShowModalRemove] = useState(false);
  const [idItemWillRemove, setIdItemWillRemove] = useState('');
  const [nameItemWillRemove, setNameItemWillRemove] = useState('');
  const handleModalConfirmYesRemove = id => {
    setShowModalRemove(false);
    dispatch(removeIVRs(id));
  };
  const [showModalRestore, setShowModalRestore] = useState(false);
  const [idItemWillRestore, setIdItemWillRestore] = useState('');
  const [nameItemWillRestore, setNameItemWillRestore] = useState('');
  const handleModalConfirmYesRestore = id => {
    setShowModalRestore(false);
    dispatch(restoreIVRs({ _id: id, active: true }));
  };

  useEffect(() => {
    dispatch(getAllIVRs());
    dispatch(getAllIVRsOptions());
  }, [dispatch]);

  const columns = [
    {
      title: 'ID',
      data: '_id',
      orderable: false,
      render: data => data || '---'
    },
    {
      title: 'Nome',
      data: 'name',
      render: data => data || '---'
    },
    {
      title: 'Departamento',
      data: 'department.name',
      render: data => data || '---'
    },
    {
      title: 'Grupo',
      data: 'deviceId.number',
      render: data => data || '---'
    },
    {
      title: 'Descrição',
      data: 'description',
      render: data => data || '---'
    },
    {
      title: 'Ações',
      data: '_id',
      orderable: false,
      className: 'no-export',
      render: (data, type, obj) => {
        return `<div class="btn-group">
                  <button id="${data}" type="button" title="Atualizar Áudio" class="btn btn-warning button-action button-action-update m-1 rounded"><i class="fa fa-upload"></i></button>
                  <button id="${data}" type="button" title="Opções URA" class="btn btn-dark button-action button-action-options m-1 rounded"><i class="fa fa-th"></i></button>
                  ${
                    !obj.active
                      ? ''
                      : `<button id="${data}" type="button" title="Excluir URA" class="btn btn-danger button-action button-action-delete m-1 rounded"><i class="fa fa-trash"></i></button>`
                  }
                  ${
                    obj.active
                      ? ''
                      : `<button id="${data}" type="button" title="Restaurar URA" class="btn btn-info button-action button-action-restore m-1 rounded"><i class="fas fa-trash-restore-alt"></i></button>`
                  }
                </div>`;
      }
    }
  ];

  const buttons = [
    {
      extend: 'copy',
      className: 'btn btn-dark fa fa-copy',
      title: 'Relatorio Copiado',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'excel',
      className: 'btn btn-dark fa fa-file-excel',
      title: 'Relatorio Excel',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'csv',
      className: 'btn btn-dark fa fa-file-csv',
      title: 'Relatorio CSV',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'pdf',
      className: 'btn btn-dark fa fa-file-pdf',
      title: 'Relatorio PDF',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'print',
      className: 'btn btn-dark fa fa-file',
      title: 'Relatorio Print',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    }
  ];

  const handleUpdateButton = id => {
    const url = '/ivrs/edit/' + id;
    dispatch(push(url));
  };

  const handleDeleteButton = dataRow => {
    setNameItemWillRemove(dataRow.name);
    setIdItemWillRemove(dataRow._id);
    setShowModalRemove(true);
  };

  const handleRestoreButton = dataRow => {
    setNameItemWillRestore(dataRow.name);
    setIdItemWillRestore(dataRow._id);
    setShowModalRestore(true);
  };

  const handleOptionsButton = dataRow => {
    const url = '/ivrs/options/' + dataRow._id;
    dispatch(push(url));
  };

  return (
    <div className="container-fluid">
      <ModalRemoveItem
        showModal={showModalRemove}
        handleModalClose={() => setShowModalRemove(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRemove(idItemWillRemove)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja excluir a URA'}
        nameItemWillRemove={nameItemWillRemove}
      />
      <ModalRestoreItem
        showModal={showModalRestore}
        handleModalClose={() => setShowModalRestore(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRestore(idItemWillRestore)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja restaurar a URA'}
        nameItemWillRestore={nameItemWillRestore}
      />
      <TableHeader
        title={'URA - Áudios'}
        url={'/ivrs/add'}
        updateList={() => {
          dispatch(getAllIVRs());
          dispatch(getAllIVRsOptions());
        }}
        isFetching={ivrs.isFetching}
      />
      <Datatable
        data={tableData}
        columns={columns}
        buttons={buttons}
        order={[[1, 'asc']]}
        handleUpdateButton={handleUpdateButton}
        handleDeleteButton={handleDeleteButton}
        handleRestoreButton={handleRestoreButton}
        handleOptionsButton={handleOptionsButton}
      />
    </div>
  );
}

export default List;
